export default "__VITE_ASSET__BZG1VPFK__"